
import cms from '~/mixins/common/cms'
import { PIXEL_EVENTS } from '~/utils/constants'
export default {
    name: 'CommonsVerticalFloatingIcons',
    mixins: [cms],
    props: {
        items: {
            type: Array,
            required: true,
            default: () => {},
        },
        componentCode: {
            type: String,
            required: true,
            default: '',
        },
    },
    methods: {
        openNewWindow(link) {
            // Track contact event when click floating icons
            this.trackPixelEvent(PIXEL_EVENTS.contact)
            window.open(
                !link.toLowerCase().startsWith('http')
                    ? 'http://' + link
                    : link,
                'Google',
                'width=550,height=600'
            )
        },
    },
}
